<div style="height:100%;" [class.ourAppEvent]=ourAppEvent>
    <our-app *ngIf="ourAppEvent"></our-app>
    <router-outlet></router-outlet>
</div>
<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Message important</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" [innerHtml]="alert">
    </div>
</ng-template>